import React, { useState } from 'react';
import clsx from 'clsx';
import analytics from 'utils/analytics';

interface AccordionProps {
    title?: string;
    tracking?: boolean;
    trackingAction?: string;
    trackingLabel?: string;
    children?: React.ReactNode;
}

const Accordion = ({
    title = 'Menu Item',
    tracking,
    trackingAction = 'ACCORDION_CLICK',
    trackingLabel,
    children,
}: AccordionProps) => {
    const [isOpen, setIsOpen] = useState(false);

    const handleClick = () => {
        setIsOpen(state => !state);
        if (tracking && isOpen) {
            analytics.sendButtonEvent(trackingAction, trackingLabel || title);
        }
    };

    return (
        <div className="sm-accordion">
            {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
            <div // NOSONAR: styled via .menu-item-container which relies on div defaults
                onClick={handleClick}
                className={clsx('menu-item-container', { open: isOpen })}
            >
                <div className="menu-item-content">
                    {title && <p className="menu-item-title">{title}</p>}
                </div>
                <div className="menu-item-arrow">
                    <i className="fa fa-caret-right" />
                </div>
            </div>
            <div className={clsx('accordion-item', { collapsed: !isOpen })}>
                <div className="accordion-content">{children}</div>
            </div>
        </div>
    );
};

export default Accordion;
